import { Component, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    standalone: false
})
export class DropdownComponent implements OnInit {


  @Input("options") options: string[] = [];
  @Input("value") value: any;
  @Input("placeholder") placeholder: string;
  @ViewChild("optionsElement", { static: false }) optionsElement: any;
  @ViewChild("inputElement", { static: false }) inputElement: any;

  @Output() valueChange = new EventEmitter<string>();
  showingOptions = false;

  constructor(private renderer2: Renderer2) { }

  ngOnInit() {
  }

  toggleDropdown() {
    this.showingOptions = !this.showingOptions;
  }

  select(item: string) {
    this.toggleDropdown();
    this.value = item
    this.valueChange.emit(item)
  }


  ngAfterViewInit() {
    this.renderer2.listen('window', 'click', (e: Event) => {

      if( this.inputElement.nativeElement.contains(e.target as Node) ){
        return
      }

      if (this.showingOptions && !this.optionsElement.nativeElement.contains(e.target as Node)) {
        this.showingOptions = false;
      }
    });
  }


}
